import {AbstractModalView} from "./AbstractModalView";
import {IModalView} from "./IModalView";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {ModalFlagModel} from "../models/ModalFlagModel";
import {IModalController, MK_MODAL_FLAG} from "../controllers/IModalController";
import {effect, inject, untracked} from "@angular/core";
import {ControllerEventBus} from "../event-buses/controller.event-bus";

export abstract class AbstractMainModalView<ControllerType extends IModalController> extends AbstractModalView<ControllerType> implements IModalView<ControllerType> {

  protected readonly flagModel: ModalFlagModel;

  protected constructor(dialogService: DialogService,
                        dialogRef: DynamicDialogRef) {
    super(dialogService, dialogRef);

    this.getController().handle('Init', this.getData());

    const subEventBus = inject(ControllerEventBus, {optional: true, self: true});
    if(subEventBus) {
      this.getController().handle('SubEventBus', {
        subEventBus: subEventBus,
      });
    }

    this.flagModel = this.getController().getModel(MK_MODAL_FLAG);

    effect(() => {
      if(this.flagModel.close$()) {
        untracked(() => {
          this.close();
        });
      }
      else if(this.flagModel.closeWithResult$()[0]) {
        untracked(() => {
          this.close(this.flagModel.closeWithResult$()[1]);
        });
      }
    });
  }
}
